import { createFileRoute } from '@tanstack/react-router';

import DeviceDetails from '@/ui/pages/DeviceDetails/DeviceDetails';

export const Route = createFileRoute('/_dashboard/devices/$id/')({
  component: DeviceDetails,
});
